import { useCallback, useEffect, useRef, useState } from 'react';
import { HEADER_WHATSAPP_CALLS_PHONE_ICON_ID } from '../../modules/calls/headerWhatsappCallsIds';

export default function useHeaderWhatsappCallsAnchor(rootId) {
  const [anchorEl, setAnchorEl] = useState(null);
  const anchorRef = useRef(null);

  useEffect(() => {
    const el = document.getElementById(rootId);
    if (!el) return undefined;

    anchorRef.current = el;
    setAnchorEl(el);
    const phoneIcon = el.querySelector('img')
      ?? document.getElementById(HEADER_WHATSAPP_CALLS_PHONE_ICON_ID);
    phoneIcon?.removeAttribute('onclick');

    return undefined;
  }, [rootId]);

  const bindClick = useCallback((handler) => {
    if (!anchorEl) return undefined;

    anchorEl.addEventListener('click', handler);
    return () => anchorEl.removeEventListener('click', handler);
  }, [anchorEl]);

  return { anchorEl, anchorRef, bindClick };
}
